var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUser = function SvgUser(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 20.9905V22.3468C8.34998 22.5603 11.1462 23.997 16 23.997C20.8538 23.997 23.6504 22.5619 24 22.3484V20.9905C24 19.2744 20.193 17.9397 19.9216 17.8376C19.07 19.3659 17.8111 20.5 16 20.5C14.1899 20.5 12.9313 19.3671 12.0798 17.84C11.8112 17.9409 8 19.2709 8 20.9905ZM10.5 11.1786C10.5 8.31856 12.9624 6 16 6C19.0376 6 21.5 8.31856 21.5 11.1786C21.5 12.3923 21.288 14.2545 20.7136 15.9962C22.7165 16.7614 26 18.0007 26 20.9905V22.9976C26 24.1027 21.6849 26 16 26C10.3151 26 6 24.0989 6 22.9976V20.9905C6 17.9904 9.28531 16.7625 11.2872 15.9988C10.7122 14.2563 10.5 12.3929 10.5 11.1786ZM16 18.5C17.9696 18.5 19.5 14.8826 19.5 11.1786C19.5 9.45095 17.959 8 16 8C14.041 8 12.5 9.45095 12.5 11.1786C12.5 14.8826 14.0304 18.5 16 18.5Z",
    fill: "#828282"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.3bfe62dd8c151eec9788e78daff9a3d4.svg";